import React, { useState } from 'react';
import { forgotPassword } from '../../services/authService';
// import Toast from '../common/Toast';
import axios from 'axios';
import { toast } from 'react-toastify';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     try {
  //       await forgotPassword(email);
  //       Toast.success('Password reset link sent to your email.');
  //     } catch (error) {
  //       Toast.error('Failed to send password reset link.');
  //     }
  //   };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await axios.post('/api/auth/forgot-password', { email });
      const response = await axios.post('/api/auth/forgot-password', { email });

      setMessage('Password reset link has been sent to your email.');

      toast.success('Password reset link sent to your email.');
    } catch (error) {
      toast.error('Failed to send reset link.');
      setMessage('Failed to send reset link. Please check your email.');
    }
  };
  // return (
  //   <div className='p-6'>
  //     <h1 className='text-2xl font-bold mb-4'>Forgot Password</h1>
  //     <form onSubmit={handleSubmit}>
  //       <div className='mb-4'>
  //         <label className='block text-sm font-medium text-gray-700'>
  //           Email
  //         </label>
  //         <input
  //           type='email'
  //           value={email}
  //           onChange={(e) => setEmail(e.target.value)}
  //           className='w-full p-2 border rounded'
  //           required
  //         />
  //       </div>
  //       <button
  //         type='submit'
  //         className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700'
  //       >
  //         Send Password Reset Link
  //       </button>
  //     </form>
  //   </div>
  // );
  return (
    <div className='flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900'>
      <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md'>
        <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
          Forgot Password
        </h2>
        {message && <p className='text-green-500 mb-4'>{message}</p>}
        <form onSubmit={handleSubmit}>
          <div className='mb-4'>
            <label className='block text-gray-700 dark:text-gray-200'>
              Email
            </label>
            <input
              type='email'
              className='w-full p-2 border border-gray-300 dark:border-gray-700 rounded mt-1'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type='submit'
            className='bg-blue-500 dark:bg-blue-700 text-white p-2 rounded hover:bg-blue-600 dark:hover:bg-blue-800'
          >
            Send Reset Link
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
